import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Dialog } from '@mui/material';
// routes
import MyAvatar from 'components/MyAvatar';
// import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import { createPartnerUsersApi } from 'redux/analytics/analyticsApi';
// import { useDispatch } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import DialogData from 'pages/spEmployees/components/DialogData';
import { getEmployeeByEmployeeIdApi } from 'redux/spEmployee/spEmployeeApi';
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import { MIconButton } from '../../components/@material-extend';
import MenuPopover from '../../components/MenuPopover';
import UserProfileDialog from '../../pages/user/components/UserProfileDialog';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  // {
  //   label: 'Home',
  //   icon: homeFill,
  //   linkTo: '/'
  // },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '/'
  }
  // {
  //   label: 'Settings',
  //   icon: settings2Fill,
  //   linkTo: '/'
  // }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { user = {}, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [openUserDetailDialog, setUserDetailDialog] = useState(false);
  const [userData, setUserData] = useState({});
  // const dispatch = useDispatch();
  const { spEmployeeDetail = {} } = useSelector(({ spEmployeeReducer }) => spEmployeeReducer);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleUserData = async () => {
    if (user?.role === 'EMPLOYEE') {
      const params = {};
      params.employeeId = user?.employeeId;
      params.userName = user?.oemId;
      let res = await dispatch(getEmployeeByEmployeeIdApi(params));
      res = unwrapResult(res);
    } else {
      setUserData(user);
    }
    setUserDetailDialog(true);
    setOpen(false);
  };

  const storeEndTime = async () => {
    try {
      const endTime = new Date();
      await localStorage.setItem('AppEndTime', endTime.toISOString()); // Serialize Date to ISO string

      // Retrieve start time and end time from localStorage
      const startingTimeStr = await localStorage.getItem('AppStartTime');
      const endingTimeStr = await localStorage.getItem('AppEndTime');

      if (startingTimeStr && endingTimeStr) {
        const startingTime = new Date(startingTimeStr); // Deserialize ISO string to Date
        const endingTime = new Date(endingTimeStr); // Deserialize ISO string to Date

        console.log('Starting Time:', startingTime);
        console.log('Ending Time:', endingTime);

        const timeDifferenceMs = endingTime - startingTime;
        console.log('Time difference in milliseconds:', timeDifferenceMs);
        await dispatch(
          createPartnerUsersApi({
            module: 'SCREEN_MODE',
            event: 'OFFLINE',
            message: 'Screen Monitor',
            startTime: startingTime,
            moduleInformation: user?.userId,
            endTime: endingTime,
            totalTimeDuration: timeDifferenceMs,
            platform: 'ADMIN_PAGE',
            phoneNumber: user?.contactInfo?.phoneNumber?.primary || ''
          })
        );

        await logout();
        navigate('/');
        setTimeout(() => {
          window.location.reload(false);
        }, 500);
      }

      console.log('App end time stored:', endTime);
    } catch (error) {
      console.error('Error saving end time:', error);
    }
  };

  const handleLogout = async () => {
    try {
      if (user?.role === 'OEM') {
        storeEndTime();
      }
      if (user?.role !== 'OEM') {
        await logout();
        navigate('/');
        setTimeout(() => {
          window.location.reload(false);
        }, 500);
      }
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout', { variant: 'error' });
    }
  };

  return (
    <>
      <Dialog fullScreen open={openUserDetailDialog} onClose={() => setUserDetailDialog(false)}>
        {user?.role === 'EMPLOYEE' ? (
          <DialogData
            setEmployeeDetailDialog={setUserDetailDialog}
            employeeData={spEmployeeDetail}
            employeeLoginId={user?.userName}
          />
        ) : (
          <UserProfileDialog setUserDetailDialog={setUserDetailDialog} userData={userData} />
        )}
      </Dialog>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 37,
          height: 37,
          mr: 2,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <MyAvatar />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user?.ownerName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {/* {user?.email} */}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            // to={option.linkTo}
            component={RouterLink}
            onClick={handleUserData}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
